import { createStore, useStore } from 'zustand'

interface DialogStoreActions {
  openDialog: (id: string, data?: any) => void
  closeDialog: (submitted?: boolean) => void
}
interface DialogStore {
  current: string | null
  open: boolean
  isSubmitting: boolean
  hasSubmitted: boolean
  dialogData: Record<string, any>
  actions: DialogStoreActions
}

const dialogStore = createStore<DialogStore>((set, get) => ({
  current: null,
  open: false,
  isSubmitting: false,
  hasSubmitted: false,
  dialogData: {},

  actions: {
    openDialog: (id, data = {}) =>
      set({
        current: id,
        open: true,
        isSubmitting: false,
        hasSubmitted: false,
        dialogData: { ...get().dialogData, [id]: data },
      }),

    closeDialog: (submitted) => set({ open: false, hasSubmitted: !!submitted }),
  },
}))

const useDialogStore = <T,>(selector: (state: DialogStore) => T): T =>
  useStore(dialogStore, selector)

export const useSubmittedDialog = () =>
  useDialogStore((state) => !state.open && state.hasSubmitted)

export const useDialogIsOpen = (id: string) =>
  useDialogStore((state) => state.current === id && state.open)

export const useDialogData = (defaultValue?: any) => {
  const data = useDialogStore((state) => {
    if (!state.current) return
    return state.dialogData[state.current]
  })

  return data || defaultValue
}

export const useDialogActions = () => useDialogStore((state) => state.actions)

export const getDialogActions = () => dialogStore.getState().actions
